import type { QueryError } from '@montugroup/circuit-shared/utils/getQueryClient';

/**
 * Both product queries' error configs live here so the two customer types cannot drift apart.
 * `LIST_AVAILABLE_PRODUCTS_QUERY_ERROR` is also shared with the pre-migration escript controller.
 */
export const PATIENT_REFILL_QUERY_ERROR: QueryError = {
  message: 'Page load error',
  log: 'Call to fetch patient refill data failed',
  showToast: true,
};

export const LIST_AVAILABLE_PRODUCTS_QUERY_ERROR: QueryError = {
  message: 'Page load error',
  log: 'Call to fetch available medications and devices failed',
  showToast: true,
};
